import AccountPicker from "../../components/AccountPicker";
import type { Dispatch, SetStateAction } from "react";
import type { Account, ExpenseInput, Trip } from "../../types";
import { inferCurrencyForDestination } from "../../lib/countries";

export interface EntryAccountFieldProps {
  entryType: string;
  input: ExpenseInput;
  setInput: Dispatch<SetStateAction<ExpenseInput>>;
  accounts: Account[];
  trips: Trip[];
  tripAccounts: Account[];
  curTrip?: Trip;
  destination?: Account;
  profileNames: string[];
}

export default function EntryAccountField({
  entryType,
  input,
  setInput,
  accounts,
  trips,
  tripAccounts,
  curTrip,
  destination,
}: EntryAccountFieldProps) {
  const changeAccount = (nextAccId: string) => {
    const nextAcc = accounts.find((a) => a.id === nextAccId);
    const activeTrip = trips.find((t) => t.id === input.tripId);
    let nextDest = input.tripDestination;
    if (activeTrip && nextAcc) {
      const inferred = activeTrip.destinations.find(
        (d) => inferCurrencyForDestination(d) === nextAcc.currency,
      );
      if (inferred) nextDest = inferred;
    }
    setInput((v) => ({
      ...v,
      accountId: nextAccId,
      toAccountId: v.toAccountId === nextAccId ? "" : v.toAccountId,
      tripDestination: nextDest,
      exchangeRate: nextAcc?.currency === destination?.currency ? "1" : "",
    }));
  };
  return <AccountPicker required label={entryType === "Income" ? "Received into" : "From account"}
    accounts={accounts.filter(a => a.active !== false || a.id === input.accountId)} value={input.accountId}
    onChange={changeAccount} tripAccounts={tripAccounts} tripName={curTrip?.name} />;
}
